import { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, Popconfirm, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import API from '../api/client';

const BannersPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try { const res = await API.get('/banners'); setData(res.data); }
    catch { message.error('Veriler yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const openCreate = () => { setEditingId(null); form.resetFields(); setModalOpen(true); };
  const openEdit = (record) => { setEditingId(record._id); form.setFieldsValue(record); setModalOpen(true); };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (editingId) { await API.put(`/banners/${editingId}`, values); message.success('Güncellendi'); }
      else { await API.post('/banners', values); message.success('Eklendi'); }
      setModalOpen(false); fetchData();
    } catch { /* validation */ }
  };

  const handleDelete = async (id) => {
    await API.delete(`/banners/${id}`); message.success('Silindi'); fetchData();
  };

  const columns = [
    { title: 'Etiket', dataIndex: 'label', key: 'label' },
    { title: 'Metin', dataIndex: 'text', key: 'text', ellipsis: true },
    { title: 'Buton', dataIndex: 'buttonText', key: 'buttonText' },
    {
      title: 'İşlem', key: 'actions', width: 120,
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => openEdit(record)} />
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Reklam Yönetimi</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>Yeni Reklam</Button>
      </div>
      <Table columns={columns} dataSource={data} rowKey="_id" loading={loading} />
      <Modal title={editingId ? 'Reklam Düzenle' : 'Yeni Reklam'} open={modalOpen} onOk={handleSave} onCancel={() => setModalOpen(false)} okText="Kaydet" cancelText="İptal">
        <Form form={form} layout="vertical">
          <Form.Item name="label" label="Etiket"><Input placeholder="REKLAM ALANI" /></Form.Item>
          <Form.Item name="text" label="Metin" rules={[{ required: true }]}><Input.TextArea rows={2} /></Form.Item>
          <Form.Item name="buttonText" label="Buton Metni"><Input /></Form.Item>
          <Form.Item name="buttonLink" label="Buton Linki"><Input /></Form.Item>
          <Form.Item name="image" label="Görsel URL"><Input /></Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default BannersPage;
